import { ToastConstants } from './constants'
import { ToastState, ToastAction } from './types'

const initialState: ToastState = {
  count: 0,
  toasts: [],
}

export function toasts(
  state: ToastState = initialState,
  action: ToastAction
): ToastState {
  switch (action.type) {
    case ToastConstants.ADD_ERROR_TOAST:
      return {
        ...state,
        count: state.count + 1,
        toasts: [...state.toasts, { ...action.toast, id: state.count + 1 }],
      }
    case ToastConstants.ADD_SUCCESS_TOAST: {
      return {
        ...state,
        count: state.count + 1,
        toasts: [...state.toasts, { ...action.toast, id: state.count + 1 }],
      }
    }
    case ToastConstants.CLEAR_ALL_TOASTS: {
      return {
        ...state,
        count: 0,
        toasts: [],
      }
    }

    default:
      return state
  }
}
